var r = {};
export {
  r as __exports
};
//# sourceMappingURL=use-sync-external-store-with-selector.production.js.map
